<template>
  <div class="search_div">
    <div class="loading" v-if="isLoading"><img src="../../assets/images/loading.gif" alt=""></div>
    <div class="hot littleroom" v-else>
      <div class="hot_title">
        <img src="../../assets/images/v.png" alt="">
        {{$t('lang.jbgnl')}}
        <span >约嘉宾线上，私密私聊！</span>
      </div>
      <div class="rooms">
        <div class="room" v-for="item in roomList" :key="item.id">
          <div class="room_item" @click="getLinkDh(item)">
            <img :src="item.thumbnail_url" alt="">
            <div class="room_border"></div>
            <div class="room_content">
              <div class="title">{{item.title}}</div>
              <div class="time">{{getDate(item.start_time, item.end_time)}} {{getTime(item.start_time, item.end_time)}}</div>
              <div class="join" v-if="item.play_status === -1">已结束</div>
              <div class="join" v-else>我要连麦</div>
            </div>
            <div class="intro"><strong>{{item.zoom_room_url}}</strong>{{item.description}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "zoom.less";
</style>
<script>
import ModalApi from '../../components/ModalApi'
export default {
  mixins: [ModalApi],
  data () {
    return {
      roomList: [],
      isLoading: true
    }
  },
  created () {
    this.getRoomList()
  },
  watch: {
    '$i18n.locale': {
      handler: function (newer, older) {
        this.getRoomList()
      },
      deep: true // 开启深度监听
    }
  },
  methods: {
    getRoomList: function () {
      let self = this
      let lang = 'zh-cn'
      if (self.$i18n.locale === 'zh') {
        lang = 'zh-cn'
      } else {
        lang = 'en-us'
      }
      self.$http.get('https://goapi.gmic.cn/api/v1/zooms?lang=' + lang).then(function (res) {
        // console.log('rooms')
        console.log(res)
        if (res.data.code === 200) {
          self.roomList = res.data.data
          self.isLoading = false
        }
      }).catch(function (err) {
        console.log(err)
        self.isLoading = true
      })
    },
    getDate: function (begin, end) {
      let begindate = begin.substring(5, 10)
      let enddate = end.substring(5, 10)
      let date = ''
      if (begindate === enddate) {
        date = begin.substring(5, 10)
      } else {
        date = begindate + '-' + enddate
      }
      return date
    },
    getTime: function (begin, end) {
      let time = begin.substring(11, 16) + '-' + end.substring(11, 16)
      return time
    },
    getLinkDh: function (item) {
      let self = this
      let finishStatus = self.$store.state.login.finishStatus
      let jump = localStorage.getItem('isClickJump')
      if (!finishStatus && !jump) {
        self.$router.replace({
          path: '/login'
        })
        return
      }
      if (item.play_status !== -1) {
        self.alert({slot: 'slotB'}, '嘉宾面对面', '确认')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/zoom/zoom.vue